export const baseName = 'livedune';
